
import React, { useEffect, useMemo, useState, Suspense, lazy } from 'react';
import { commonGet } from '../../../services/CommonService';


const ViewMarks =({user}) =>{

    const[marks,setMarks] = useState([]);

    useEffect(() => {

        console.log(user);
        getMarks();

    }, []);

    const getMarks =async() =>{

        const reqparam ={
            pageno:'-1',
            ptype:'USERMARKS',
            query:{userid:user.id}

        }

        const EduResponse = await commonGet(reqparam);
        setMarks(EduResponse.data);
    }

    return(<>
     <div className="col-12">
      <div className="card">
        
        <div className="card-body">
          <div className="table-responsive">
            <div id="job_data" className="dataTables_wrapper">
              <table
                className="display w-100 dataTable "
                id="example5"
                role="grid"
                aria-describedby="example5_info"
              >
                <thead>
                  <tr role="row">
                    <th className="sorting_asc" style={{ width: "177px" }}>
                      Education
                    </th>
                    <th className="sorting" style={{ width: "178px" }}>
                      Branch
                    </th>
                    <th className="sorting" style={{ width: "128px" }}>
                      Semister
                    </th>
                    <th className="sorting" style={{ width: "128px" }}>
                       Marks
                    </th>
                    
                  </tr>
                </thead>

                <tbody>
                 

                  {marks.map(( listValue, index ) => {
                    return (
                      <tr key={index}>
                        <td>{listValue.groupname}</td>
                        <td>{listValue.branchname}</td>
                        <td>{listValue.semistername}</td>
                        <td>{listValue.marks}</td>
                      </tr>
                    );
                  })}
                 
                </tbody>
               
              </table>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    </>)
}

export default ViewMarks